import type { ScreenModule } from "../../../app/screen-module";
import { PublicAgentsPage } from "../pages";

export default {
	id: "public.agents",
	path: "/agents",
	area: "public",
	navGroup: "サービス案内",
	label: "Agent一覧",
	roles: [],
	backing: "MOCK_ONLY",
	enabled: true,
	component: PublicAgentsPage,
} satisfies ScreenModule;
